// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"db52314a","211":"7f375eee","238":"a1d91b0d","453":"6d265c4a"}[chunkId] + ".chunk.js";
};